import styled from "styled-components";

import { colorsPalettes, mixins, fonts, setFontVariant } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

export const StyledModalHeader = styled.h2`
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    padding: 20px 24px;
    margin: 0 0 8px 0;
    ${mixins.setFont({
        $size: 20,
        $weight: 500,
        $color: colorsPalettes.carbon[500],
        $family: fonts.$dmSansFontFamily,
    })};
    line-height: 24px;
`;

export const StyledEmptyList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-height: 525px;
    height: calc(100vh - 280px);
`;

export const StyledEmptyListTitle = styled.h3`
    ${mixins.setFont({
        $size: 32,
        $weight: 500,
        $family: fonts.$dmSansFontFamily,
        $color: colorsPalettes.carbon[400],
    })};
    text-align: center;
    line-height: 40px;
    margin: 0 0 16px;
`;

export const StyledEmptyListDescription = styled.p`
    ${mixins.setFont({
        $size: 16,
        $weight: 400,
        $color: colorsPalettes.carbon[400],
    })};
    line-height: 20px;
    margin: 0;
`;

export const StyledEmptyListSubtitle = styled(StyledEmptyListDescription)`
    ${mixins.setFont({ $weight: 500 })};
`;

export const StyledFooter = styled.div`
    box-sizing: border-box;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    padding: 16px 16px 16px 12px;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const StyledFooterText = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
`;

export const StyledFooterCounter = styled.span`
    ${setFontVariant("subTitle3", colorsPalettes.carbon[400])};
`;

export const StyledButtonsWrapper = styled.div`
    display: inline-flex;
    justify-content: flex-end;
`;

export const StyledCancelButton = styled(Button)`
    margin-right: 4px;
`;
